import {
    TextField,
    Button,
    styled,
    List,
    ListItem,
} from '@material-ui/core';
import { RemoveButtonAdornment } from './taster-fields';

export const EditBeerList = styled(p =>
    <List {...p} />
)({
    paddingTop: 0
});

export const EditBeerItem = styled(({ className, onRemove, id, ...p }) =>
    <ListItem disableGutters dense className={className}>
        <TextField
            variant="outlined"
            margin="normal"
            id={id}
            name={p?.name}
            value={p?.name}
            fullWidth
            placeholder="Beer Name"
            InputProps={{
                endAdornment: (
                    <RemoveButtonAdornment onRemove={onRemove} />
                )
            }}
            autoComplete="off"
            {...p}
        />
    </ListItem>
)({
    paddingTop: 0
});

export const AddBeerButton = styled(p =>
    <Button variant="outlined" {...p} color="primary">Add Beer</Button>
)(({ theme }) => ({
    width: '100%',
    height: 46,
    borderRadius: 10,
    borderWidth: 1.5,
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    marginTop: theme.spacing(0.5),
    '&:hover': {
        borderWidth: 1.5,
    },
}));
